import React, { useEffect, useState } from "react";
import { commonPostApi } from "../../../utils/apiService";
import {
  generateColumnMetadata,
  orderObj,
} from "../../../utils/utils";
import DataGrid from '../../../components/common/dataGrid/dataGrid';
import { useSelector } from "react-redux";
import { SORT_ORDER } from "../../../constants/sortOrder";
import { PatientReportListColumns } from "../../../utils/serviceData";

export default function AllReport({
  api,
  dashboardApi,
  visit,
  selectable = false,
  columnArray = [],
  date,
  search = "",
  setCampPatientDashboard,
  parentSetProducts,
  parentSetValues,
  parentSetNavigator   
}) {
  const [values, setValues] = useState([]);
  const [columns, setColumns] = useState([]);
  const [loading, setLoading] = useState(false);
  const id = useSelector(state => state.common.camp?.camp_details_id);
  const [navigator, setNavigator] = useState({
    page: 1,
    first: 0,
    rows: 10,
    totalRecords: 1,
    sortBy: "patient_name",
    sortDir: SORT_ORDER.ASC,
    purpose: visit,
  });
  const init = async (navigator) => {
    let query = {
      page: navigator?.page,
      limit: navigator?.rows,
      purpose: navigator?.purpose,
      startDate: date.startDate,
      endDate: date.endDate,
      searchValue: navigator?.searchValue,
      sortFields: navigator?.sortFields,
    };
    let dashboardQuery = {
      startDate: date.startDate,
      endDate: date.endDate,
      searchValue: navigator?.searchValue,
    };
    let headers = {
      "Content-Type": "application/json",
    };
    let orderArray = [
      "patient_name",
      "patient_code",
      "aadhar_no",
      "total_amount",
      "total_paid",
      "total_due",
      "treatment_recommended"
    ];
    setLoading(true);
    if (columnArray && columnArray?.length > 0) {
      orderArray = [...orderArray, ...columnArray];
    }

    try {
      const [data = {}, campDashboard = []] = await Promise.all([
        commonPostApi(api, query, { headers }),
        commonPostApi(dashboardApi, dashboardQuery, { headers }),
      ]);

      const campData = campDashboard?.data?.data;
      setCampPatientDashboard(campData);
      if (data?.data?.data) {
        const finalData = data?.data?.data;
        setNavigator((prev) => {
          const updated = {
            ...prev,
            totalRecords: data?.data?.total,
            page: data?.data?.currentPage,
          };
          parentSetNavigator(updated);
          return updated;
        });

        const orderedProducts = orderObj(
          orderArray,
          generateColumnMetadata({
            data: finalData,
            alias: {
              patient_code: "patient_id",
              aadhar_no: "aadhar",
              total_amount: "total",
              total_paid: "paid amt",
              total_due: "balance",
              treatment_recommended: "treatment type",
            },
            defaultColumnsArr:PatientReportListColumns,
          })?.filter((item) => orderArray?.includes(item?.name))
        );
        setColumns(orderedProducts);
        setValues(finalData);

        parentSetProducts(orderedProducts);
        parentSetValues(finalData);

        setLoading(false);
      } else {
        setNavigator((prev) => ({
          ...prev,
          totalRecords: 1,
          page: 1,
        }));
      }
    } catch (err) {
      console.error(err);
    }
  };
  function onPageChange(event) {
    setLoading(true);
    setNavigator((prev) => ({
      ...prev,
      first: event?.first,
      page: event.page + 1,
    }));
    init({
      ...navigator,
      first: event?.first,
      page: event.page + 1,
    });
  }

  const onRowCountChange = (e) => {
    setLoading(true);
    setNavigator((prev) => ({
      ...prev,
      rows: e?.target?.value,
      page: 1,
      first: 0,
    }));
    init({
      ...navigator,
      page: 1,
      first: 0,
      rows: e?.target?.value,
    });
  };
  useEffect(() => {
    setNavigator((prev) => ({
      ...prev,
      searchValue: search,
    }));
    init({
      ...navigator,
      searchValue: search,
    });
  }, [id, date, search]);

  const onSortClick = (event) => {
    setLoading(true);
    const sortOrder = event?.sortOrder === 1 ? SORT_ORDER.ASC : SORT_ORDER.DESC;
    setNavigator((prev) => ({
      ...prev,
      sortBy: event?.sortField,
      sortDir: sortOrder,
      sortFields: [[event?.sortField, sortOrder]],
    }));
    init({
      ...navigator,
      sortBy: event?.sortField,
      sortDir: sortOrder,
      sortFields: [[event?.sortField, sortOrder]],
    });
  };

  return (
    <div>
      <DataGrid
        selectable={selectable}
        onRowCountChange={onRowCountChange}
        onPageChange={onPageChange}
        onSortClick={onSortClick}
        navigator={navigator}
        column={columns}
        value={values}
        loading={loading}
        isAccordionEnabled={false}
        isPaginatorEnabled={true}
        sortable
      />
    </div>
  );
}
